import { useSnackbar } from 'notistack';
import { useQuery } from 'react-query';
import { useHttp } from 'shared/providers/provide-http';
import { CompetitorProductDropdown } from 'types/backend';

export function useCompetitorProductOptions(competitorName: string) {
    const http = useHttp();
    const { enqueueSnackbar } = useSnackbar();
    const { data, isFetching, isLoading } = useQuery<CompetitorProductDropdown[], Error>(
        ['competitorProductDropdown', competitorName],
        async () => {
            if (!competitorName) {
                return [];
            }
            const { data } = await http.post(`api/competitorProducts/dropdown`, { competitorName });

            return data || [];
        },
        {
            onError: (error) => enqueueSnackbar(error.message, { variant: 'error' }),
            keepPreviousData: true,
            refetchOnWindowFocus: false,
        }
    );
    return { data, isFetching, isLoading } as const;
}
